// The Job Complete "Device" card (NEU-1119). It showed the phone's own connection as the
// device's status, so a Tjommie that was off could read "Connected".

/** The device the card is about: the new unit for an install or a replacement, the removed
 *  one for an uninstall. Only a device that stays on site gets a status check. */
export function cardDevice(job) {
  if (job?.install_state === "UN") {
    return { serial: job.archived_serial_number, imsi: job.archived_imsi_number, checkStatus: false };
  }
  return { serial: job?.device_serial_number, imsi: job?.device_imsi_number, checkStatus: !!job?.device_serial_number };
}

/** What the status row says, from the device-status lookup. */
export function deviceStatusLabel({ isLoading, isError, connected }) {
  if (isLoading) return { text: "Checking…", tone: "muted" };
  if (isError) return { text: "Couldn't check", tone: "muted" };
  return connected ? { text: "Device online", tone: "ok" } : { text: "Device offline", tone: "bad" };
}
